import { render } from "./hero.vue?vue&type=template&id=5efc1319&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=5efc1319&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5efc1319"

export default script